import { __awaiter } from "tslib";
import { derived, writable } from "../util/customStores";
import { interpolate } from "../../shared/util/template";
import logger, { LogCategory } from "../util/logger";
import { parse as parseYaml } from "yaml";
import { language } from "../store/settings";
import text from "../store/text";
export var MessageType;
(function (MessageType) {
    MessageType["ERROR"] = "ERROR";
    MessageType["WARNING"] = "WARNING";
    MessageType["SUCCESS"] = "SUCCESS";
    MessageType["INFO"] = "INFO";
    MessageType["BUG"] = "BUG";
})(MessageType || (MessageType = {}));
export default class MessageFeed {
    constructor() {
        this._messages = writable([]);
        this.messages = derived(this._messages, $instructions => $instructions);
    }
    error(message, expiresInSec = 5) {
        return this.addMessage({
            type: MessageType.ERROR,
            message,
            expiresInSec
        });
    }
    warning(message, expiresInSec = 5) {
        return this.addMessage({
            type: MessageType.WARNING,
            message,
            expiresInSec
        });
    }
    success(message, expiresInSec = 5) {
        return this.addMessage({
            type: MessageType.SUCCESS,
            message,
            expiresInSec
        });
    }
    info(message, expiresInSec = 5) {
        return this.addMessage({
            type: MessageType.INFO,
            message,
            expiresInSec
        });
    }
    bug(message, expiresInSec = MessageFeed.NO_EXPIRE) {
        return this.addMessage({
            type: MessageType.BUG,
            message,
            expiresInSec
        });
    }
    addMessage(message) {
        const messageId = Math.random();
        this._messages.set([
            ...this._messages.get(),
            Object.assign({ id: messageId }, message)
        ]);
        return messageId;
    }
    deleteMessage(messageId) {
        this._messages.update(messages => {
            return messages.filter(m => m.id !== messageId);
        });
    }
    fetchMessages(messagesUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            logger.debug("Fetching messages", LogCategory.INIT);
            yield fetch(messagesUrl)
                .then(res => res.text())
                .then(text => parseYaml(text))
                .then((data) => {
                logger.debug(`Messages fetched - ${data.messages.length} messages found`, LogCategory.INIT);
                data.messages.forEach((message) => {
                    this.addMessage({
                        message: message.message[language.get()],
                        type: message.type,
                        expiresInSec: message.expiresInSec
                    });
                });
            })
                .catch(error => {
                logger.unexpected_error(error.message, LogCategory.INIT);
                this.error(interpolate(text.get().errors.generic.fetch_error, messagesUrl));
            });
        });
    }
}
MessageFeed.NO_EXPIRE = -1;
